<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form>
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="1"
              vs-sm="4"
              vs-xs="12"
            >
              <vs-button
                @click="goBack"
                color="danger"
                type="border"
                icon="keyboard_backspace"
                >Back</vs-button
              >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="9"
              vs-sm="4"
              vs-xs="12"
            >
              <h3>Add New Master Step</h3>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
            </vs-col>
          </vs-row>
          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Steps:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="steps"
                v-model="steps.steps"
                v-validate="'required'"
                data-vv-as="Steps"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('steps')"
              >{{ errors.first("steps") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Steps Description:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="description"
                v-model="steps.description"
                v-validate="'required'"
                data-vv-as="Steps Description"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('description')"
              >{{ errors.first("description") }}</span
            >
          </div>
                 <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Phase:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <v-select
                  label="name"
                  name="phase"
                  :options="phase"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  v-model="steps.phase"
                                  v-validate="'required'"
                />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('phase')"
              >{{ errors.first("phase") }}</span
            >
          </div>
          
          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full"></div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-button class="mr-3 mb-2" @click.prevent="submitForm"
                >Submit</vs-button
              >
            </div>
          </div>
                   <vs-table
        class="mb-10"
        @search="handleSearch"
        @sort="handleSort"
        v-model="selected"
        stripe
        :data="allSteps"
      >
        <template slot="thead">
          <!-- <vs-th sort-key="s_no">S No.</vs-th> -->
          <vs-th sort-key="Steps">Steps</vs-th>
          <vs-th sort-key="Steps_description">Description</vs-th>
                    <vs-th sort-key="phase">Phase</vs-th>

        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <!-- <vs-td :data="data[indextr]">
              {{ indextr + 1 }}
            </vs-td> -->
            <vs-td :data="data[indextr].steps">
              {{ data[indextr].steps }}
            </vs-td>
            <vs-td :data="data[indextr].description">
              {{ data[indextr].description }}
            </vs-td>
              <vs-td :data="data[indextr].phase">
              {{ data[indextr].phase }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
        </vx-card>
      </form>

    </div>
  </div>
</template>
<script>
// Store Module
import defineAbilitiesFor from "@/config/abilities";
import moduleMasterStepsManagement from "@/store/campaign-management/master-steps-management/moduleMasterStepsManagement.js";
import vSelect from "vue-select";
export default {
  data() {
    return {
      selected:[],
      allSteps:[],
          paginationAttr: {
      page_no: 1,
      per_page: 100    },
      abilities: null,

      steps: {
        steps: null,
        description: null,
        phase:null
      },
      phase: [{
        name: 'Setup',
        value: 'Setup'
      },{
        name: 'In Market',
        value: 'In Market'
      },{
        name: 'Wrap up',
        value: 'Wrap up'
      },{
        name: 'Onboarding',
        value: 'Onboarding'
      }]
    };
  },
  components: {
    "v-select": vSelect,
    moduleMasterStepsManagement
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });
    if (!moduleMasterStepsManagement.isRegistered) {
      this.$store.registerModule("MasterStepsManagement", moduleMasterStepsManagement);
      moduleMasterStepsManagement.isRegistered = true;
    }
  },
  mounted() {
    this.fetchAllMasterSteps()
  },
  methods: {
      handleSearch(searching) {
      console.log(`The Steps searched for: ${searching}`);
    },
    handleSort(key, active) {
      console.log(`the Steps ordered: ${key} ${active}`);
    },
        fetchAllMasterSteps() {
      this.$store
        .dispatch(
          "MasterStepsManagement/fetchAllMasterSteps",
          this.paginationAttr
        )
        .then(res => {
          this.allSteps =
            moduleMasterStepsManagement.state.steps.datas;
        })
        .catch(err => {
          console.log(err);
                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    goBack: function() {
      this.$router.go(-1);
    },
    submitForm() {
      this.$validator.validateAll().then(result => {
        if(result){
        this.addSteps();

        }
      });
    },
    addSteps() {
      this.$store
        .dispatch("MasterStepsManagement/addSteps", this.steps)
        .then(res => {
          if (res.data.status == "fail") {
            this.$vs.notify({
              color: "danger",
              title: "Master Steps Exists",
              text: res.data.message
            });
          } else {
            this.$vs.notify({
              color: "success",
              title: "Steps Added",
              text: "The master steps was added successfully"
            });
            this.$router.push({ path: "/campaigns/master-steps" });
          }
        })
        .catch(err => {
                      console.log(err);

                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    }
  }
};
</script>
<style scoped>
.removeButton {
  cursor: pointer;
}
</style>
